<dd class="font-medium inline-block " [class.text-primary]="value === 'Miễn phí'" [class.text-red-500]="value !== 'Miễn phí'">{{value}}</dd>